import {gql} from "@apollo/client"

export const CURRENT_USER = gql`
  query Me {
    me {
      uuid
      dateOfBirth {
        day
        month
        year
        __typename
      }
      businessId
      email
      externalUserId
      firstName
      gender
      isEnabled
      isActivated
      lastName
      language
      metadata {
        createdAt
        createdBy
        __typename
      }
      marketingEmailsAllowed
      phoneNumber
      profileImageUrl
      source
      teamIds
      isManagedExternally
      isGlobalAdmin
      role
      primaryTeamId
      teamAssignments {
        teamId
        assignment
        __typename
      }
      __typename
    }
  }
`
